import React from 'react';
import { ThoughtMarkdown } from '../ThoughtMarkdown';
import { ToolResultProps } from '../types';

const DefaultToolResult: React.FC<ToolResultProps> = ({ thought, onDocumentClick }) => {
  const { content, success, toolResult } = thought;
  const displayContent = content || toolResult?.content || '';
  const isSuccess = success !== false;

  // Convertir onDocumentClick a onViewDocument
  const onViewDocument = onDocumentClick ? (url: string, name: string) => {
    // onDocumentClick espera (documentId, url, name) pero no tenemos el ID aquí
    // Solo pasamos url y name
    if (url) {
      onDocumentClick('', url, name);
    }
  } : undefined;

  return (
    <div className="mt-1.5 px-1">
      {/* Eliminado el header redundante - ya se muestra en ThoughtItem */}
      <div className={`text-[11px] leading-relaxed ${isSuccess ? 'text-foreground/70' : 'text-red-700/80'}`}>
        {displayContent ? (
          <ThoughtMarkdown
            content={displayContent}
            fontSize="text-[11px]"
            textColor={isSuccess ? 'text-foreground/70' : 'text-red-700/80'}
            onViewDocument={onViewDocument}
          />
        ) : (
          <span className="text-[10px] text-muted-foreground italic">No response content.</span>
        )}
      </div>
    </div>
  );
};

export default DefaultToolResult;
